export default __webpack_public_path__ + "static/media/elevate-bbl-banner-2.6397ccb3.jpg";